import React from "react";
import SeraloginOnlineHeader from "./SeraloginOnlineHeader";

const SeraloginOnlineLayout = ({ children }) => {
  return (
    <div className="seralogin-online-layout">
      <SeraloginOnlineHeader />
      <div className="page-content">{children}</div>
    </div>
  );
};

export default SeraloginOnlineLayout;
